import AssociateSelect from './associateSelect';

export default AssociateSelect;
